<h2>Dokumententypen</h2>

<a routerLink="/profil/documenttypes/add" matButton="elevated" color="primary">
    Neuen Dokumenttyp Anlegen
</a>
<div>
    <table mat-table [dataSource]="data" class="full-width data-table">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let documentType">
                {{ documentType.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="showColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let documentType">
                <button matButton="elevated" color="accent">Anzeigen</button>
            </td>
        </ng-container>

        <ng-container matColumnDef="editColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let documentType">
                <a routerLink="/profil/documenttypes/edit/{{
                        documentType.id
                    }}" matButton="elevated" color="primary">Bearbeiten</a>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let documentType; columns: displayedColumns" class="element-row"></tr>
    </table>
</div>